export default "__VITE_ASSET__c09d22dd__"